import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import fetchJsonp from 'fetch-jsonp';
import { itunesByCollectionId } from '../../lib/searchItunes';

import Loading from './Loading';
import AppSideScroll from './AppSideScroll';
import Podcast from '../Podcast/Podcast';
import { sortNumericallyLastDesc } from '../../lib/utils';
import AppSpacer from './AppSpacer';
import { spacing } from '../../lib/theme';
import { bindActionCreators } from 'redux';
import { getRecentPodcasts } from '../../actions';
import EmptyState from './EmptyState';

const maxRecentNumber = 4;

class RecentPodcasts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itunesData: undefined, loading: true, windowWidth: undefined
        };
    }

    componentDidMount() {
        // const { recentPlayedEpisodes } = this.props;
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        const { personalValues } = this.props;
        if (prevProps.personalValues != personalValues) {
            this.fetchData();
        }
    }
    fetchData = () => {
        const { personalValues } = this.props;
        this.props.getRecentPodcasts(personalValues);
    }

    render() {
        const { itunesData, loading, windowWidth } = this.state;
        const { recentPodcasts } = this.props;
        // if (loading) {
        //     return <Loading />
        // }
        if (!recentPodcasts || recentPodcasts.length < 1) {
            return (<EmptyState imageHeight='200px'
                message="Your recent books will show up here." imageName="empty" />)
        }
        console.dir(recentPodcasts);
        return (
            <div>
                {/* <AppSideScroll title='Recently Played' showScroll={false}> */}
                <div className='flex'>
                    {
                        recentPodcasts.filter((el, ind) => windowWidth < 1080 ? ind < 2 : true).map((podcast, index) =>
                            <div key={index} style={{ marginRight: `${spacing('lg')}` }}>
                                <Podcast className='cards' podcast={podcast} showSubscribe={false} size='lg' />
                                {/* <AppSpacer /> */}
                            </div>
                        )
                    }
                    {/* </AppSideScroll> */}
                </div>
                <style jsx>
                    {`
                    .flex {
                        display: flex;
                        flex-wrap: wrap;
                        // justify-content: space-between;
                    }
                        `}
                </style>
            </div>
        )
    }
}

RecentPodcasts.propTypes = {
    // recentPlayedEpisodes: PropTypes.object.isRequired,
    // itunesData: PropTypes.array,
    recentPodcasts: PropTypes.array,
    personalValues: PropTypes.object,
    getRecentPodcasts: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        recentPodcasts: state.recentPodcasts,
        personalValues: state.personalValues,
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        getRecentPodcasts: bindActionCreators(getRecentPodcasts, dispatch),
        // deleteInsights: bindActionCreators(deleteInsights, dispatch),
        // setAllEpisodesAsPlayed: bindActionCreators(setAllEpisodesAsPlayed, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RecentPodcasts);
